import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import VehicleId from '|/app/vehicle/[vehicleId]';
import ErrorRoute from '|/helpers/error-route';
import useDocumentTitle from '|/helpers/use-document-title';
import ProtectedRoute from '../protect-route';

const ContentWrapper = styled.div`
  padding-bottom: 90px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VehicleMissing = lazy(() =>
  import(/* webpackChunkName: "vehicle-missing" */ '|/app/vehicle/missing')
);

const VehicleSoldOnLot = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-sold-on-lot" */ '|/app/vehicle/sold-on-lot'
  )
);

const VehicleUnavailable = lazy(() =>
  import(
    /*  webpackChunkName: "vehicle-unavailable" */ '|/app/vehicle/unavailable'
  )
);

const VehicleConfirmation = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-confirmation" */ '|/app/vehicle/confirmation'
  )
);

const VehicleErrorPrice = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-error-price" */ '|/app/vehicle/error-price'
  )
);

const VehicleResumePurchase = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-resume-purchase" */ '|/app/vehicle/resume'
  )
);

const VehicleStartPurchase = lazy(() =>
  import(
    /* webpackChunkName: "vehcile-startpurchase" */ '|/app/vehicle/startpurchase'
  )
);

const ReservationError = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-reservationerror" */ '|/app/vehicle/reservation-error'
  )
);

const VehicleExchange = lazy(() =>
  import(/* webpackChunkName: "vehicle-exchange" */ '|/app/vehicle/exchange')
);

const VehicleRoutes = () => {
  useDocumentTitle('Vehicle');

  return (
    <Routes>
      <Route
        path=":vehicleId"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleId />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="reservation-error"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <ReservationError />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="missing"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleMissing />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="confirmation/:vehicleId"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleConfirmation />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="resume/:vehicleId"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleResumePurchase />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="startpurchase/:vehicleId"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleStartPurchase />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="unavailable/:vehicleId"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleUnavailable />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="sold-on-lot"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleSoldOnLot />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="exchange/:vehicleId"
        element={
          <ContentWrapper>
            <VehicleExchange />
          </ContentWrapper>
        }
      />
      <Route
        path="error-price"
        element={
          <ProtectedRoute>
            <ContentWrapper>
              <VehicleErrorPrice />
            </ContentWrapper>
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <ErrorRoute />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default VehicleRoutes;
